module.exports = __webpack_public_path__ + "img/icon-plan-duplicate.7f36dbd5.svg";